import React from 'react';
import { DATA_KEYS } from 'shared/constants';
import { Breadcrumbs } from '../../../components/breadcrumbs';
import { KnowledgeSectionList, KnowledgeSection, RenderSectionList } from './components';
import styles from './knowledge.module.scss';
import { ScreenTitle } from 'src/components/design-system';
import { ViewSelector } from 'src/components/common/view-selector';
import classnames from 'classnames';
import { usePageTitle } from 'src/components/app/use-page-title';
const { KNOWLEDGE_BASE } = DATA_KEYS;

const KnowledgePageComponent = React.memo(
  ({
    id,
    title,
    children = null,
    knowledgeItems = [],
    updatedAt,
    fullPath = '',
    pathParts = [],
    ownerIds = [],
    tags,
    shared,
    workspaceId,
    isRoot = false,
    isReady = false,
  }) => {
    const { updateSubtitle } = usePageTitle();

    React.useEffect(() => {
      updateSubtitle(title);
    }, [title, updateSubtitle]);

    const renderContent = () => {
      if (knowledgeItems.length) {
        // TODO: Add redirect to parent category with opened knowledge items list
        return (
          <KnowledgeSection
            {...{ title, children, knowledgeItems, updatedAt, fullPath, ownerIds, tags, shared }}
          />
        );
      }

      return (
        <KnowledgeSectionList
          isReady={isReady}
          list={children}
          ownerIds={ownerIds}
          fullPath={fullPath}
          id={id}
          tags={tags}
          shared={shared}
        />
      );
    };

    return (
      <div
        className={classnames([styles.root, 'new-design-system'])}
        data-key={KNOWLEDGE_BASE.LIST}>
        <aside>
          <RenderSectionList sections={children} />
        </aside>
        <main>
          <div className={styles.header}>
            <div className={styles.headerTitle}>
              {!isRoot && (
                <Breadcrumbs
                  pathParts={pathParts}
                  title={title}
                  initialWorkspaceId={workspaceId}
                  sectionLinks
                />
              )}
              <ScreenTitle title={title} />
            </div>
            <ViewSelector />
          </div>
          {renderContent()}
        </main>
      </div>
    );
  },
);

export { KnowledgePageComponent };
